import { Alert, Button, Checkbox, Form } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useValidateChoosingAtLeastOneAlertType } from './components/useValidateChoosingAtLeastOneAlertType';

const CaptchaAndButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

const validateMessages = {
    required: 'Syötä sähköpostiosoite',
    types: {
        email: 'Syötä sähköpostiosoite',
    }
};

const SendButtonContainer = styled(Button)`
    @media screen and (max-width: 600px) {
        width: 100%;
    }
`;

export default function ConfigurationForm(): ReactElement {
    const [hasErrors, setHasErrors] = useState(true);
    const [form] = Form.useForm();
    const [naturalForestAlerts, setNaturalForestAlerts] = useState(true);
    const [observationAlerts, setObservationAlerts] = useState(true);
    const [activationId, setActivationId] = useState<string>();
    const loc = useLocation();
    const [maintenanceBreak, setMaintenanceBreak] = useState(false);
    const [requestOk, setRequestOk] = useState<boolean | undefined>(undefined);
    const [activated, setActivated] = useState<boolean | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(false);

    const chooseAtLeastOneAlertTypeValidation = useValidateChoosingAtLeastOneAlertType(naturalForestAlerts, observationAlerts, form);

    const getActivation = (id: string) => {
        const asyncCall = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetAlertsConfiguration?id=${id}`);

            if (response.ok) {
                const activation = await response.json();

                setNaturalForestAlerts(activation.naturalForestAlerts);
                setObservationAlerts(activation.observationAlerts);
                setActivated(activation.activated);
            }
            else {
                setRequestOk(false);
            }
        }

        asyncCall();
    };

    useEffect(() => {
        const search = loc.search || "";
        const split = search.split("=");

        if (split.length === 2) {
            const id = split[1];

            setActivationId(id);
            getActivation(id);
        }
    }, []);

    const saveChanges = async () => {
        try {
            setIsLoading(true);

            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/SaveAlertsConfiguration?id=${activationId}`, {
                body: JSON.stringify({
                    naturalForestAlerts,
                    observationAlerts
                }),
                method: "POST"
            });

            if (res.ok) {
                setRequestOk(true);
            }
            else {
                if ((await res.text()) === "HUOLTOKATKO") {
                    setMaintenanceBreak(true);
                }
                setRequestOk(false);
            }
        } catch (error) {
            setRequestOk(false);
        }
        finally {
            setIsLoading(false);
        }
    };


    const handleFieldsChange = (s: any, state: any[]) => {
        const hasAnyErrors = state.some((val: any) => val.errors.length > 0);

        setHasErrors(hasAnyErrors);
    };

    return (
        <div>
            {requestOk === false && <div>
                <Alert type="error" message="Tapahtui virhe. Ole hyvä ja kokeile uudestaan." />
            </div>}

            {requestOk === true && <div>
                <Alert type="success" message="Muutosten tallennus onnistui!" />
            </div>}

            {activated === false && <div>
                <Alert type="error" message="Sähköpostiosoitetta ei ole vielä aktivoitu, ole hyvä ja klikkaa saamassasi sähköpostissa olevaa aktivointilinkkiä ensin." />
            </div>}

            {activated && <Form form={form} validateMessages={validateMessages} onFinish={saveChanges} onFieldsChange={handleFieldsChange}>
                <Form.Item
                    name={"naturalForests"}
                    label="Hälytykset luonnonmetsistä"
                    validateFirst={false}
                    rules={[
                        {
                            validator: chooseAtLeastOneAlertTypeValidation,
                        }
                    ]}>
                    <Checkbox checked={naturalForestAlerts} indeterminate={false} defaultChecked={true}
                        onChange={() => setNaturalForestAlerts(!naturalForestAlerts)}></Checkbox>
                </Form.Item>

                <Form.Item
                    name={"observations"}
                    label="Hälytykset lajihavainnoista"
                    validateFirst={false}
                    rules={[
                        {
                            validator: chooseAtLeastOneAlertTypeValidation,
                        }
                    ]}>
                    <Checkbox checked={observationAlerts} indeterminate={false} defaultChecked={true}
                        onChange={() => setObservationAlerts(!observationAlerts)}></Checkbox>
                </Form.Item>

                <CaptchaAndButtonsContainer>
                    <SendButtonContainer loading={isLoading} type="primary" htmlType="submit" value="Lähetä" disabled={hasErrors}>Tallenna</SendButtonContainer>
                </CaptchaAndButtonsContainer>
            </Form>}
        </div >
    )
}
